// extracted by mini-css-extract-plugin
export default {"cBadge":"Badge_cBadge__l-ghw"};